import * as React from 'react';
import * as cls from 'classnames';
import { withRouter } from 'react-router-dom';
import { Errors, LocalForm, Control, actions } from 'react-redux-form';

import * as CreDtos from "../../../CRE.dtos";

import TextFormGroup from "../../Controls/TextFormGroup";
import TextAreaFormGroup from "../../Controls/TextAreaFormGroup";
import ValidationMessage from "../../Controls/ValidationMessage";
import * as Config from '../../../configuration/consts';
import { required, maxLength, numberRange, url } from "../../Validators/";
import {
    mapProps,
    showErrors,
    updateOn,
    validateOn,
} from "../../Controls/ReactReduxFormSettings";


@withRouter
export class AddItem extends React.Component<any, any> {
    formDispatch;
    constructor(props) {
        super(props);
        this.state = { resourceType: "LINK", confirmDelete: false };
        this.onResourceTypeChange = this.onResourceTypeChange.bind(this);
        this.onLocalSubmit = this.onLocalSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onCancelClicked = this.onCancelClicked.bind(this);
    }

    onDeleteClicked() {
        this.setState({ confirmDelete: !this.state.confirmDelete });
    }

    onCancelClicked() {
        this.props.clearResource();
    }

    onResourceTypeChange(event) {
        this.setState({ resourceType: event.target.value });
    }

    onLocalSubmit(values) {
        this.onSubmit(values);
    }

    componentDidMount() {
        if (this.props.resource) {
            if (this.formDispatch) {
                this.formDispatch(actions.change('resource', this.props.resource));
                window.scrollTo(0, 0);
            }
        }
    }

    componentDidUpdate(prevProps, prevState){
        if(this.props.resource && !this.props.resource.id && this.state.confirmDelete){
            this.onDeleteClicked();
        }
        if(this.formDispatch && prevProps.resource !== this.props.resource){
            let resource = this.props.resource ? this.props.resource : {};
            this.formDispatch(actions.change('resource', resource));
        } else if(this.formDispatch
            && prevProps.activeFilter
            && prevProps.activeFilter.id != this.props.activeFilter.id) {
            this.formDispatch(actions.reset('resource'));
        }
    }

    async onSubmit(form) {
        let resource = new CreDtos.ForumResource();
        resource = {...form};
        resource.linkType = form.type;
        resource.obsolete = this.state.confirmDelete;

        if(this.props.activeFilter){
            let tag = new CreDtos.ForumTagSummary() ;
            tag.id = this.props.activeFilter.id;
            let tags: CreDtos.ForumTagSummary[] = [tag];
            resource.tags = tags;
        }


        if(form.files && form.files.length > 0){
            let file = form.files[0];
            let attachment = new CreDtos.ForumAttachment();
            attachment.fileName = file.name;
            attachment.fileType = file.type;
            attachment.data = await this.getEncodedFile(file);
            resource.file = attachment;
        }

        this.props.saveResource(this.props.forum.id, resource);
        this.formDispatch(actions.reset('resource'));
        this.setState({ linkType: Config.ATTACH_LINK });
    }

    async getEncodedFile(file: File) {
        return new Promise<string>((resolve, reject) => {
            var reader = new FileReader();

            reader.onload = (event: any) => {
                var binaryString = reader.result;
                var encoded = btoa(binaryString);
                resolve(encoded);
            };
            reader.readAsBinaryString(file);
        });
    }

    render() {
        const { resource, ...props } = this.props;
        let rescourceType = this.state.resourceType === Config.ATTACH_LINK ?
            <Control.text
                model=".link"
                id="resource.link"
                type="url"
                component={TextFormGroup}
                placeholder="Link... (include http://)"
                validators={{
                    url: url
                }}
                updateOn={updateOn}
                validateOn={validateOn}
                mapProps={mapProps}
                maxLength={255}
                controlProps={{
                    validate: true
                }}
            >
                <Errors
                    model=".link"
                    messages={{
                        url: "URL is not valid"
                    }}
                    show={showErrors}
                    component={ValidationMessage}
                />
            </Control.text> :
            <Control.file model=".files" placeholder="File..." className="form-control" />;

        let deleteButton = resource && resource.id ? <span><a className="btn btn-danger mr-2" onClick={this.onDeleteClicked}>DELETE</a><button className="btn btn-primary mr-2" onClick={this.onCancelClicked}>CANCEL</button></span> : undefined;
        let resourceActions = this.state.confirmDelete ? <div className="alert alert-warning alert-dismissible fade show">
            <span className="fa fa-warning fa-2x mr-2"></span>
            Are you sure you want to delete this resource?
                <a className="btn btn-default lightgrey-bg mx-2 pull-right" onClick={this.onDeleteClicked}>NO</a><button type="submit" className="btn btn-default pull-right">YES</button>
        </div> : <div className="pull-right">{deleteButton}<button className="btn btn-default" onClick={this.onCancelClicked}>CANCEL</button><button type="submit" className="btn btn-primary">SAVE</button></div>;

        return (<LocalForm model="resource" onSubmit={this.onLocalSubmit.bind(this)} getDispatch={(dispatch) => this.formDispatch = dispatch}
            validateOn="submit">
            <div className="card lightgrey-bg">
                <div className="card-block">
                    <strong>ADD NEW RESOURCE</strong>
                    <div className="row">
                        <div className="col-12 mb-1">
                            <Control.text
                                model=".title"
                                id="resource.title"
                                component={TextFormGroup}
                                placeholder="Title..."
                                validators={{
                                    required: required,
                                    maxLength: maxLength.bind(null, 150)
                                }}
                                updateOn={updateOn}
                                validateOn={validateOn}
                                mapProps={mapProps}
                                maxLength={150}
                                controlProps={{
                                    validate: true
                                }}
                            >
                                <Errors
                                    model=".title"
                                    messages={{
                                        maxLength: "Title is too long",
                                        required: "Title is required"
                                    }}
                                    show={showErrors}
                                    component={ValidationMessage}
                                />
                            </Control.text>
                        </div>
                        <div className="col-12 mb-1">
                            <Control.textarea
                                model=".summary"
                                id="resource.summary"
                                component={TextAreaFormGroup}
                                rows={3}
                                placeholder="Summary..."
                                validators={{
                                    maxLength: maxLength.bind(null, 1000)
                                }}
                                updateOn={updateOn}
                                validateOn={validateOn}
                                mapProps={mapProps}
                                maxLength={1000}
                                controlProps={{
                                    validate: true
                                }}
                            >
                                <Errors
                                    model=".summary"
                                    messages={{
                                        maxLength: "Summary is too long"
                                    }}
                                    show={showErrors}
                                    component={ValidationMessage}
                                />
                            </Control.textarea>
                        </div>
                        <div className="col-9 mb-1">
                            <Control.text
                                model=".author"
                                id="resource.author"
                                component={TextFormGroup}
                                placeholder="Author..."
                                validators={{
                                    maxLength: maxLength.bind(null, 150)
                                }}
                                updateOn={updateOn}
                                validateOn={validateOn}
                                mapProps={mapProps}
                                maxLength={150}
                                controlProps={{
                                    validate: true
                                }}
                            >
                                <Errors
                                    model=".author"
                                    messages={{
                                        maxLength: "Author is too long"
                                    }}
                                    show={showErrors}
                                    component={ValidationMessage}
                                />
                            </Control.text>
                        </div>
                        <div className="col-3 mb-1">
                            <Control.text
                                model=".year"
                                id="resource.year"
                                component={TextFormGroup}
                                placeholder="Year..."
                                validators={{
                                    numberRange: numberRange.bind(null, 1800, 2100)
                                }}
                                updateOn={updateOn}
                                validateOn={validateOn}
                                mapProps={mapProps}
                                maxLength={4}
                                controlProps={{
                                    validate: true
                                }}
                            >
                                <Errors
                                    model=".year"
                                    messages={{
                                        numberRange: "Year is not valid"
                                    }}
                                    show={showErrors}
                                    component={ValidationMessage}
                                />
                            </Control.text>
                        </div>
                        <div className="col-12 mb-1">
                            <select
                                className="form-control"
                                onChange={this.onResourceTypeChange}
                                defaultValue={this.state.resourceType}>
                                <option value={Config.ATTACH_LINK}>Link</option>
                                <option value={Config.ATTACH_FILE}>File</option>
                            </select>
                        </div>
                        <div className="col-12 mb-1">{rescourceType}</div>
                    </div>
                    {resourceActions}
                </div>
            </div>
        </LocalForm>);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/Resources/AddItem.tsx